import { commafy, toEnglishDigits } from '../../utils/methods';
import { _post } from '../../utils/network';
import { contentLevelLabel, contentLevelOptions } from '../../utils/content-level';

export { toShamsiDate } from '../Blog/blogUtils';
export { contentLevelLabel, contentLevelOptions };

/** Missing course types belong to the original video-based course offering. */
export const getCourseType = course => course?.course_type === 'in_person' ? 'in_person' : 'online';

export const courseTypeOptions = t => [
	{ key: t('course_type_online'), value: 'online' },
	{ key: t('course_type_in_person'), value: 'in_person' }
];

export const courseTypeLabel = (course, t) => courseTypeOptions(t).find(item => item.value === getCourseType(course)).key;

/** Normalize localized digits without silently accepting fractions or signed values. */
export const parseCourseCapacity = value => {
	const normalized = toEnglishDigits(String(value ?? '').trim());
	if(!/^\d+$/.test(normalized))
		return null;
	const capacity = Number(normalized);
	return Number.isInteger(capacity) && capacity > 0 && capacity <= 2147483647 ? capacity : null;
};

/** Course categories as FormField select items. */
export const fetchCourseCategoryOptions = async () => {
	const response = await _post('/course_categories/admin/getCourseCategories', {});
	if(response.code !== 200)
		return { options: [], response };
	return { options: response.data.course_categories.map(category => ({ key: category.title, value: category.id })), response };
};

/** Same price units as shop products. */
export const coursePriceUnits = t => [
	{ key: t('score2_name'), value: 'zar' },
	{ key: `${t('score1_name')} ${t('and')} ${t('score2_name')}`, value: 'sim_zar' }
];

export const formatCoursePrice = (course, t) => {
	if(course?.is_free)
		return t('free');
	const unit = coursePriceUnits(t).find(item => item.value === course?.price_unit)?.key || '';
	return `${commafy(course?.price ?? 0)} ${unit}`.trim();
};

export const isHttpUrl = value => /^https?:\/\/\S+$/i.test(value);
